/**
 * A component used to show the list of sessions with the date range filter.
 * @author Rajkumar.N
 */
import React from "react";
import DateRangePicker from "../../../components/DateRangePicker";
import SessionHistory from "./SessionHistory";

/**
 *  A component used to show the list of sessions with the date range filter.
 */
class SessionsScreen extends React.Component {

  constructor() {
    super();
    this.startDate = "";
    this.endDate = "";
    this.state = {
      startDate: "",
      endDate: ""
    }
  }

  updateDates() {
    this.setState({
      startDate: this.startDate,
      endDate: this.endDate
    });
  }

  render() {
    return (
      <div>
        <DateRangePicker
          showCalendarImage={true}
          onChangeStartDate={startDate => {
            this.startDate = startDate;
            // This check is used to avoid the if only startDate is selected and not selected any endDate then we should update the SessionHistory props.
            if (this.endDate) {
              this.updateDates();
            }
          }}
          onChangeEndData={endDate => {
            this.endDate = endDate;
            // This check is used to avoid the if only endDate is selected and not selected any startDate then we should update the SessionHistory props.
            if (this.startDate) {
              this.updateDates();
            }
          }}
          onChangeRangeFilter={(startDate, endDate) => {
            this.startDate = startDate;
            this.endDate = endDate;
            this.setState({
              startDate: startDate,
              endDate: endDate
            });
          }}
        />
        <SessionHistory
          startDate={this.state.startDate}
          endDate={this.state.endDate} />
      </div>
    );
  }
}

export default SessionsScreen;
